// @ts-nocheck — same opt-out precedent as socket-configurator.js.
//
// Plain Add to Order — for standalone accessory products (shades/bulbs/
// samples sold separately from a lamp) with no configurator segments at
// all. See blocks/plain-add-to-order.liquid for the full architecture note.
// This is deliberately a small, separate script rather than a mode inside
// socket-configurator.js's initConfigurator() — that function's state is
// built entirely around segments (finish, stand, socket, ...) that don't
// exist here, so keeping this one self-contained avoids any risk of
// touching the already-proven lamp configurator flow.

import { addItem, MAX_QUANTITY } from '@theme/configurator-order';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-plain-add-to-order]').forEach(initPlainAddToOrder);
  // Belt-and-suspenders alongside the CSS sibling-selector hide in
  // plain-add-to-order.liquid — only runs when this block is actually on
  // the page, so it never touches Buy Buttons on any other template.
  if (document.querySelector('[data-plain-add-to-order]')) {
    document.querySelectorAll('.buy-buttons-block').forEach((el) => {
      el.style.display = 'none';
    });
  }
});

/** @param {HTMLElement} root */
function initPlainAddToOrder(root) {
  let quantity = 1;

  const minusEl = root.querySelector('[data-qty-minus]');
  const plusEl = root.querySelector('[data-qty-plus]');
  const inputEl = root.querySelector('[data-qty-input]');

  function setQuantity(next) {
    quantity = Math.min(MAX_QUANTITY, Math.max(1, Math.round(next) || 1));
    if (inputEl) inputEl.value = String(quantity);
  }

  if (minusEl && plusEl && inputEl) {
    inputEl.max = String(MAX_QUANTITY);
    minusEl.addEventListener('click', () => setQuantity(quantity - 1));
    plusEl.addEventListener('click', () => setQuantity(quantity + 1));
    inputEl.addEventListener('change', () => setQuantity(Number(inputEl.value)));
  }

  const addToOrderEl = root.querySelector('[data-add-to-order]');
  const statusEl = root.querySelector('[data-add-to-order-status]');
  const successEl = root.querySelector('[data-add-to-order-success]');
  const successTextEl = root.querySelector('[data-add-to-order-success-text]');
  if (!addToOrderEl) return;

  const idleLabel = addToOrderEl.textContent;
  let revertTimer = null;

  addToOrderEl.addEventListener('click', () => {
    statusEl.textContent = '';
    if (successEl) successEl.hidden = true;

    const form = document.getElementById(root.dataset.productFormId);
    const variantInput = form ? form.querySelector('input[name="id"]') : null;
    if (!variantInput || !variantInput.value) {
      statusEl.textContent = 'Could not find this product’s variant — try reloading the page.';
      return;
    }

    if (!root.dataset.orderPageUrl) {
      statusEl.textContent = 'This product isn’t set up for checkout yet — missing order page URL.';
      return;
    }

    addItem({
      variantId: `gid://shopify/ProductVariant/${variantInput.value}`,
      // No shapeId/selections — proxy.checkout.tsx treats that as a plain
      // item and keeps the native variantId link instead of building a
      // custom line, since there's no per-configuration SKU to override.
      // selections MUST stay [] (not omitted): configurator-order.js's
      // unitPrice()/configuredSku() call .reduce/.forEach on it directly.
      shapeId: null,
      shapeName: root.dataset.productName || null,
      productUrl: root.dataset.productUrl || null,
      image: root.dataset.productImage || null,
      selections: [],
      unitBasePrice: Number(root.dataset.productPrice) || 0,
      quantity,
    });

    // Same perceived-feedback pattern as socket-configurator.js: the add
    // itself is instant (client-side/localStorage), the "Adding…" pause is
    // deliberate, not an actual wait.
    clearTimeout(revertTimer);
    addToOrderEl.disabled = true;
    addToOrderEl.classList.add('is-loading');
    addToOrderEl.textContent = 'Adding…';

    setTimeout(() => {
      addToOrderEl.classList.remove('is-loading');
      addToOrderEl.classList.add('is-added');
      addToOrderEl.textContent = 'Added';

      if (successEl) {
        if (successTextEl) successTextEl.textContent = `Added ${root.dataset.productName || 'item'} to your order.`;
        successEl.hidden = false;
      }

      revertTimer = setTimeout(() => {
        addToOrderEl.classList.remove('is-added');
        addToOrderEl.textContent = idleLabel;
        addToOrderEl.disabled = false;
      }, 1600);
    }, 350);
  });
}
